import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import InputLabel from '@/components/form/base/InputLabel.tsx';
import BaseInput from '@/components/form/base/BaseInput.tsx';
import InputError from '@/components/form/base/InputError.tsx';
import { Eye, EyeOff } from 'lucide-react';

const PasswordInput = ({
  label,
  register,
  required = false,
  error,
}: {
  label: string;
  register: UseFormRegisterReturn;
  required?: boolean;
  error?: string;
}) => {
  const [isPasswordVisible, setIsPasswordVisible] = React.useState(false);

  return (
    <div className="flex w-full flex-col items-start gap-1.5">
      <InputLabel label={label} required={required} />
      <div className="relative w-full">
        <BaseInput
          type={isPasswordVisible ? 'text' : 'password'}
          register={register}
          placeholder="••••••••••"
          error={error}
        />
        <button
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 transform text-neutral-600 hover:text-neutral-700"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          aria-label={isPasswordVisible ? 'Ukryj hasło' : 'Pokaż hasło'}
        >
          {isPasswordVisible ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
      <InputError error={error} />
    </div>
  );
};

export default PasswordInput;
